import "./App.css";
import "./components/Pages/Auth/Login.css";
import {
  Routes,
  Route,
  useLocation,
  useNavigate,
  Navigate,
} from "react-router-dom";
import { lazy, Suspense, useContext, useEffect, useState } from "react";
import ScrollToTopButton from "./components/include/ScrollToTopButton/ScrollToTopButton";
import { NoteState, isAdminRole } from "./Context/Notes/NoteState";
import { jwtDecode } from "jwt-decode";
import LoadingBar from "./components/include/loadingbar/LoadingBar";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-loading-skeleton/dist/skeleton.css";
import "react-toastify/dist/ReactToastify.css";
import "react-tooltip/dist/react-tooltip.css";
import "react-datepicker/dist/react-datepicker.css";

const Sidebar = lazy(() => import("./components/include/sidebar/sidebar"));
const CustomNavbar = lazy(() => import("./components/include/navbar/navbar"));
const Home = lazy(() => import("./components/Home/home"));
const AddAluminum = lazy(
  () => import("./components/Pages/AddRecord/AddAluminum"),
);
const LoginPage = lazy(() => import("./components/Pages/Auth/LoginPage"));
const AddCompany = lazy(() => import("./components/Pages/Company/Add_company"));
const AddCustomer = lazy(
  () => import("./components/Pages/Customers/AddCustomer"),
);
const ViewAluminum = lazy(
  () => import("./components/Pages/ViewRecord/ViewAluminium"),
);
const ViewAluminiumSales = lazy(
  () => import("./components/Pages/ViewRecord/ViewAluminiumSales"),
);
const ViewAluminiumSalesDetail = lazy(
  () => import("./components/Pages/ViewRecord/ViewAluminiumSalesDetail"),
);
const Invoice = lazy(() => import("./components/Pages/Cart/Invoice"));
const AluminiumSales = lazy(
  () => import("./components/Pages/Cart/AluminiumSales"),
);
const AluminiumPurchase = lazy(
  () => import("./components/Pages/Cart/AluminiumPurchase"),
);
const ViewAluminiumPurchase = lazy(
  () => import("./components/Pages/ViewRecord/ViewAluminiumPurchase"),
);
const ViewAluminiumPurchaseDetail = lazy(
  () => import("./components/Pages/ViewRecord/ViewAluminiumPurchaseDetail"),
);
const ViewGlass = lazy(() => import("./components/Pages/ViewRecord/ViewGlass"));
const GlassSales = lazy(() => import("./components/Pages/Cart/GlassSales"));
const GlassPurchase = lazy(
  () => import("./components/Pages/Cart/GlassPurchase"),
);
const AddCustomerLedger = lazy(
  () => import("./components/Pages/Ledgers/AddCustomerLedger"),
);
const ViewCustomerLedger = lazy(
  () => import("./components/Pages/Ledgers/ViewCustomerLedger"),
);
const AddSupplierLedger = lazy(
  () => import("./components/Pages/Ledgers/AddSupplierLedger"),
);
const ViewSupplierLedger = lazy(
  () => import("./components/Pages/Ledgers/ViewSupplierLedger"),
);
const WareHouse = lazy(() => import("./components/Pages/WareHouse/WareHouse"));
const ViewGlassSales = lazy(
  () => import("./components/Pages/ViewRecord/ViewGlassSales"),
);
const ViewGlassSalesDetail = lazy(
  () => import("./components/Pages/ViewRecord/ViewGlassSalesDetail"),
);
const AddStaff = lazy(() => import("./components/Pages/HR/Staff/AddStaff"));
const ViewStaff = lazy(() => import("./components/Pages/HR/Staff/ViewStaff"));
const ViewGlassPurchase = lazy(
  () => import("./components/Pages/ViewRecord/ViewGlassPurchase"),
);
const AddLoans = lazy(() => import("./components/Pages/HR/Loans/AddLoans"));
const AddFabricator = lazy(
  () => import("./components/Pages/Customers/AddFabricator"),
);
const Salaries = lazy(() => import("./components/Pages/HR/Salaries/Salaries"));
const AddCategories = lazy(
  () => import("./components/Pages/Expense/Categories/AddCategories"),
);
const SubCategories = lazy(
  () => import("./components/Pages/Expense/SubCategories/SubCategories"),
);
const AddExpenses = lazy(
  () => import("./components/Pages/Expense/AddExpense/AddExpenses"),
);
const ViewFinishedProducts = lazy(
  () => import("./components/Pages/ViewRecord/ViewFinishedProducts"),
);
const FinishedProductSales = lazy(
  () => import("./components/Pages/Cart/FinishedProductSales"),
);
const ViewFinishedSales = lazy(
  () => import("./components/Pages/ViewRecord/ViewFinishedSales"),
);
const StaffAttendance = lazy(
  () => import("./components/Pages/HR/Staff/StaffAttendance"),
);
const ViewStaffAttendance = lazy(
  () => import("./components/Pages/HR/Staff/ViewStaffAttendance"),
);
const ViewHardware = lazy(
  () => import("./components/Pages/ViewRecord/ViewHardware"),
);
const HardwareSales = lazy(
  () => import("./components/Pages/Cart/HardwareSales"),
);
const HardwarePurchse = lazy(
  () => import("./components/Pages/Cart/HardwarePurchse"),
);
const ViewHardwareSales = lazy(
  () => import("./components/Pages/ViewRecord/ViewHardwareSales"),
);
const ViewHardwareSalesDetail = lazy(
  () => import("./components/Pages/ViewRecord/ViewHardwareSalesDetail"),
);
const ViewFinishedProductsaleDetail = lazy(
  () => import("./components/Pages/ViewRecord/ViewFinishedProductsaleDetail"),
);
const ViewHardwarePurchase = lazy(
  () => import("./components/Pages/ViewRecord/ViewHardwarePurchase"),
);
const Merge = lazy(() => import("./components/Pages/MergeOrders/Merge"));
const MergeOrder = lazy(
  () => import("./components/Pages/MergeOrders/MergeOrder"),
);
const ViewMergeOrder = lazy(
  () => import("./components/Pages/MergeOrders/ViewMergeOrder"),
);
const MergedOrderSlip = lazy(
  () => import("./components/Pages/MergeOrders/MergedOrderSlip"),
);
const MergeQuotation = lazy(
  () => import("./components/Pages/MergeOrders/MergeQuotation"),
);
const ViewMergeQuotation = lazy(
  () => import("./components/Pages/MergeOrders/ViewMergeQuotation"),
);
const Documents = lazy(() => import("./components/Pages/Documents/Documents"));
const FabricatorPayments = lazy(
  () => import("./components/Pages/Customers/FabricatorPayments"),
);
const ViewFabPayments = lazy(
  () => import("./components/Pages/Customers/ViewFabPayments"),
);
const Folders = lazy(() => import("./components/Pages/Documents/Folders"));
const PayableLedger = lazy(
  () => import("./components/Pages/Ledgers/PayableLedger"),
);
const ReceiveableLedger = lazy(
  () => import("./components/Pages/Ledgers/ReceiveableLedger"),
);
const ProductWiseSalesReport = lazy(
  () => import("./components/Pages/ViewRecord/ProductWiseSalesReport"),
);

const AdminRoute = ({ children }) => {
  const { state } = useContext(NoteState);
  const { role } = state;

  if (!isAdminRole(role)) {
    return <Navigate to="/add-customers" replace />;
  }
  return children;
};
function App() {
  const [isToggled, setIsToggled] = useState(false);
  const navigate = useNavigate();
  const locate = useLocation();
  const { state, dispatch: ctxDispatch } = useContext(NoteState);
  const { accessToken, role } = state;

  useEffect(() => {
    if (accessToken) {
      try {
        const decoded = jwtDecode(accessToken);
        if (Math.floor(new Date().getTime() / 1000) > decoded.exp) {
          ctxDispatch({ type: "LOGOUT" });
          navigate("/");
        } else if (locate.pathname === "/") {
          navigate(isAdminRole(role) ? "/dashboard" : "/add-customers");
        }
      } catch (error) {
        console.error("Invalid token:", error.message);
        navigate("/");
      }
    } else {
      navigate("/");
    }
  }, [accessToken, role, ctxDispatch, locate.pathname, navigate]);

  const handleToggle = () => {
    setIsToggled(!isToggled);
  };

  const location = useLocation();
  if (location.pathname === "/") {
    return (
      <Suspense fallback={<LoadingBar />}>
        <Routes>
          <Route path="/" element={<LoginPage />} />
        </Routes>
      </Suspense>
    );
  }
  return (
    <Suspense fallback={<LoadingBar />}>
      <div>
        <Sidebar
          isToggled={isToggled}
          handleToggle={handleToggle}
          setIsToggled={setIsToggled}
        />
        <CustomNavbar isToggled={isToggled} handleToggle={handleToggle} />
        <Routes>
          <Route
            path="/dashboard"
            element={
              <AdminRoute>
                <Home isToggled={isToggled} handleToggle={handleToggle} />
              </AdminRoute>
            }
          />
          <Route
            path="/add-product"
            element={
              <AddAluminum isToggled={isToggled} handleToggle={handleToggle} />
            }
          />
          <Route
            path="/add-company"
            element={
              <AdminRoute>
                <AddCompany isToggled={isToggled} handleToggle={handleToggle} />
              </AdminRoute>
            }
          />
          <Route
            path="/add-customers"
            element={
              <AddCustomer isToggled={isToggled} handleToggle={handleToggle} />
            }
          />
          <Route
            path="/view-aluminium"
            element={
              <ViewAluminum isToggled={isToggled} handleToggle={handleToggle} />
            }
          />
          <Route
            path="/view-product-wise-sales"
            element={
              <ProductWiseSalesReport
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/aluminium-sales"
            element={
              <AluminiumSales
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/view-aluminium-sales"
            element={
              <ViewAluminiumSales
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/view-aluminium-sales-detail/:id"
            element={
              <ViewAluminiumSalesDetail
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/invoice/:id"
            element={
              <Invoice isToggled={isToggled} handleToggle={handleToggle} />
            }
          />
          <Route
            path="/aluminium-purchase"
            element={
              <AluminiumPurchase
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/view-aluminium-purchase"
            element={
              <ViewAluminiumPurchase
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/view-aluminium-purchase-detail/:id"
            element={
              <ViewAluminiumPurchaseDetail
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/view-glass"
            element={
              <ViewGlass isToggled={isToggled} handleToggle={handleToggle} />
            }
          />
          <Route
            path="/glass-sales"
            element={
              <GlassSales isToggled={isToggled} handleToggle={handleToggle} />
            }
          />
          <Route
            path="/glass-purchase"
            element={
              <GlassPurchase
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/add-customer-ledger"
            element={
              <AddCustomerLedger
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/view-customer-ledger/:id"
            element={
              <ViewCustomerLedger
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/add-supplier-ledger"
            element={
              <AddSupplierLedger
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/view-supplier-ledger/:id"
            element={
              <ViewSupplierLedger
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/manage-warehouse"
            element={
              <WareHouse isToggled={isToggled} handleToggle={handleToggle} />
            }
          />
          <Route
            path="/view-glass-sales"
            element={
              <ViewGlassSales
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/view-glass-sales-detail/:id"
            element={
              <ViewGlassSalesDetail
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/view-glass-purchase"
            element={
              <ViewGlassPurchase
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/view-glass-purchase-detail/:id"
            element={
              <ViewGlassSalesDetail
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/add-fabricators"
            element={
              <AddFabricator
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/add-staff"
            element={
              <AddStaff isToggled={isToggled} handleToggle={handleToggle} />
            }
          />
          <Route
            path="/view-staff"
            element={
              <ViewStaff isToggled={isToggled} handleToggle={handleToggle} />
            }
          />
          <Route
            path="/add-staff-loans"
            element={
              <AddLoans isToggled={isToggled} handleToggle={handleToggle} />
            }
          />
          <Route
            path="/staff-salary"
            element={
              <Salaries isToggled={isToggled} handleToggle={handleToggle} />
            }
          />
          <Route
            path="/category-details"
            element={
              <AddCategories
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/sub-category-details"
            element={
              <SubCategories
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/expense-details"
            element={
              <AddExpenses isToggled={isToggled} handleToggle={handleToggle} />
            }
          />
          <Route
            path="/view-finished-products"
            element={
              <ViewFinishedProducts
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/finished-products-sales"
            element={
              <FinishedProductSales
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/view-finished-products-sales"
            element={
              <ViewFinishedSales
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/staff-attendance"
            element={
              <StaffAttendance
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/view-staff-attendance"
            element={
              <ViewStaffAttendance
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/view-hardware"
            element={
              <ViewHardware isToggled={isToggled} handleToggle={handleToggle} />
            }
          />
          <Route
            path="/hardware-sales"
            element={
              <HardwareSales
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/hardware-purchase"
            element={
              <HardwarePurchse
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/view-hardware-sales"
            element={
              <ViewHardwareSales
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/view-hardware-sales-detail/:id"
            element={
              <ViewHardwareSalesDetail
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/view-finished-products-sales-detail/:id"
            element={
              <ViewFinishedProductsaleDetail
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/view-hardware-purchase"
            element={
              <ViewHardwarePurchase
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/merge-orders"
            element={
              <Merge isToggled={isToggled} handleToggle={handleToggle} />
            }
          />
          <Route
            path="/merge-order/:id"
            element={
              <MergeOrder isToggled={isToggled} handleToggle={handleToggle} />
            }
          />
          <Route
            path="/view-merge-orders"
            element={
              <ViewMergeOrder
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/merged-orders-invoice/:id"
            element={
              <MergedOrderSlip
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/merge-quotation"
            element={
              <MergeQuotation
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/view-merge-quotation"
            element={
              <ViewMergeQuotation
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/documents"
            element={
              <Documents isToggled={isToggled} handleToggle={handleToggle} />
            }
          />
          <Route
            path="/folders"
            element={
              <Folders isToggled={isToggled} handleToggle={handleToggle} />
            }
          />
          <Route
            path="/fabricator-payments"
            element={
              <FabricatorPayments
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/payable-ledger"
            element={
              <PayableLedger
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/receivable-ledger"
            element={
              <ReceiveableLedger
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
          <Route
            path="/view-fabricator-payments/:id"
            element={
              <ViewFabPayments
                isToggled={isToggled}
                handleToggle={handleToggle}
              />
            }
          />
        </Routes>
        <ScrollToTopButton />
      </div>
    </Suspense>
  );
}

export default App;
